import deleteModalImg from "../../assets/images/app/common/modal-delete-img.svg";
import ModalSuccessImage from "../../assets/images/app/common/check-circle-icon.svg";
import ModalDeleteImage from "../../assets/images/app/common/trash-icon.svg";

export let CONFIRMATION_MODAL_CONFIG = {
    CREATE: {
        Title: "Are you sure you wants to create ?",
        SubText: "",
        YesButtonText: "Continue",
        NoButtonText: "Cancel",
        ImageSrc: "",
    },
    REPLACE: {
        Title: "Are you sure you wants to edit ?",
        SubText: "",
        YesButtonText: "Continue",
        NoButtonText: "Cancel",
        ImageSrc: "",
    },
    UPDATE: {
        Title: "Are you sure you wants to update ?",
        SubText: "",
        YesButtonText: "Continue",
        NoButtonText: "Cancel",
        ImageSrc: "",
    },
    DELETE: {
        Title: "ARE YOU SURE YOU WANT TO DELETE ?",
        SubText: "",
        YesButtonText: "Delete",
        NoButtonText: "Cancel",
        ImageSrc: deleteModalImg,
    },
    GENERAL: {
        Title: "Are you sure you wants to",
        SubText: "",
        YesButtonText: "Continue",
        NoButtonText: "Cancel",
        ImageSrc: "",
    },
    SUCCESS: {
        Title: "Your notification message has been updated successfully",
        SubText: "",
        YesButtonText: "Done",
        showNoButton: false,
        ImageSrc: ModalSuccessImage,
    },
    SAVE: {
        Title: "Your notification message has been saved successfully",
        SubText: "",
        YesButtonText: "Done",
        showNoButton: false,
        ImageSrc: ModalSuccessImage,
    },
    DELETE_NOTIFICATION: {
        Title: "Are you sure you want to delete this notification?",
        SubText: "",
        YesButtonText: "Delete",
        NoButtonText: "Cancel",
        ImageSrc: ModalDeleteImage,
    },
    // SAVE/SUCCESS above are worded for the notification flow specifically
    // ("Your notification message has been..."), and are still used there.
    // The content library needed its own pair rather than a reworded shared
    // one: an admin who has just uploaded a video was being told their
    // notification message was saved.
    CONTENT_SAVED: {
        Title: "Your content has been uploaded successfully",
        SubText: "",
        YesButtonText: "Done",
        showNoButton: false,
        ImageSrc: ModalSuccessImage,
    },
    CONTENT_UPDATED: {
        Title: "Your content has been updated successfully",
        SubText: "",
        YesButtonText: "Done",
        showNoButton: false,
        ImageSrc: ModalSuccessImage,
    },
};

export const getConfirmationModalConfig = (
    preBuildConfig,
    type = "",
    customConfig = null
) => {
    let obj = preBuildConfig[type];

    if (customConfig) {
        obj = {
            Title: customConfig?.customTitle,
            SubText: customConfig?.customSubText,
            YesButtonText: customConfig?.customYesBtnText,
            NoButtonText: customConfig?.customNoBtnText,
            ImageSrc: customConfig?.customImageSrc,
        };
        return obj;
    } else {
        return obj;
    }
};
